import React from 'react';
import { makeDownloadButton } from 'cccisd-tabletop';
import orgAdminsQuery from './orgAdminsQuery.graphql';
import style from './style.css';

export default class OrgActivationDownload extends React.Component {
    getDownloadColumns = () => {
        return [
            { label: 'First Name', name: 'user.firstName' },
            { label: 'Last Name', name: 'user.lastName' },
            { label: 'Email', name: 'user.username' },
            { label: 'Primary Contact', name: 'fields.primaryContact' },
            { label: 'Organization', name: 'ancestorGroups.organization.fields.orgId' },
            { label: 'Last Login', name: 'user.lastLoginDate' },
            { label: 'Invited Date', name: 'user.invitedDate' },
            { label: 'Activation URL', name: 'user.activationUrl' },
        ];
    };

    renderDownloadButton = () => {
        const data = {
            tableProps: {
                columns: this.getDownloadColumns(),
                csvFilename: 'org_admins_activation.csv',
                query: orgAdminsQuery,
            },
            buttonName: 'Download Activation Info',
            buttonClass: 'btn btn-primary',
        };

        const button = makeDownloadButton(data);
        const getActualVariables = () => {
            return {
                graphqlVariables: {
                    orderBy: [{ field: 'fields.firstName', direction: 'ASC' }],
                },
            };
        };

        const Button = button({ getActualVariables });
        return Button;
    };

    render() {
        return <span className={style.btn}>{this.renderDownloadButton()}</span>;
    }
}
